package gr.tech.models.skus


enum class SKU_STATUS(val bit: Short, val status: String) {
    DELETED(0, "DELETED"),
    ACTIVE(1, "ACTIVE");

    companion object {
        fun parseStatus(status: String): SKU_STATUS {
            return when (status.lowercase()) {
                "active" -> SKU_STATUS.ACTIVE
                "deleted" -> SKU_STATUS.DELETED
                else -> SKU_STATUS.ACTIVE
            }
        }
    }

}